import Sources from 'collections/sources';

export default new Sources();
